
import {
    ApiManager,
    sessionService,
    SessionManager,
    LoggerUtility,
    EnumUtility,
    UtilityLibrary
} from '../components/ComponentsLibrary';

class CustomerDataService {
    constructor() {
        
    }

    async getCustServiceContactsFromApiByCaseID(paramsObj) {
        try {
            const csContactsApiData = await ApiManager.GetCustServiceContactsList(paramsObj);
            return csContactsApiData;

           /*  if (csContactsApiData && csContactsApiData.length > 0) {                
                return csContactsApiData;
            }
            else {
                return null;
            } */
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getCustServiceContactsFromApiByCaseID", {});
        }

    };

    async getEventsGridDataNoCaseFromApi(paramsObj) {
        try {
            const apiData = await ApiManager.GetEventsGridDataNoCaseApiUrl(paramsObj);
            return apiData;
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getEventsGridDataNoCaseFromApi", {});
        }

    };

    

}

const customerDataService = new CustomerDataService();

export default customerDataService;